<template>    
    <div class="loader-container">
    <img
      class="sheep-icon rotating-sheep"
      :src="require('@/assets/img/sheep-icon.png')"
      alt="loading"
    />
  </div>    
</template>

<script>
export default {
    name: 'Loader_icon',
    props: {
        text : {
            require: false,
            type: String,
            default: 'Loading...'
        }
    }    
};
</script>

<style scoped>
.loader-container {
  width: 80px;
  height: 80px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loader-container::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  border: 5px solid transparent;
  border-top-color: #4ca750; /* Green ring */
  border-radius: 50%;
  animation: rotate-ring 1s linear infinite;
}

.sheep-icon {
  width: 64px;
  height: 64px;
}

.rotating-sheep {
  animation: rotate-sheep 1.2s linear infinite;
  transform-style: preserve-3d;
}

@keyframes rotate-ring {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes rotate-sheep {
  0% { transform: rotateY(0deg); }
  100% { transform: rotateY(360deg); }
}
</style>